export default [
    {
        path: '/account/profile',
        component: () => import(/* webpackChunkName: "Profile" */ '@/views/Private/Pages/Account/Profile')
    },
    {
        path: '/account/security',
        component: () => import(/* webpackChunkName: "Security" */ '@/views/Private/Pages/Account/Security')
    },
    {
        path: '/team/billing',
        component: () => import(/* webpackChunkName: "TeamBilling" */ '@/views/Private/Pages/Team/Billing')
    },
	{
        path: '/team/plans',
        component: () => import(/* webpackChunkName: "TeamPlans" */ '@/views/Private/Pages/Team/Plans')
    },
	{
        path: '/team/manage',
        component: () => import(/* webpackChunkName: "TeamView" */ '@/views/Private/Pages/Team/Manage')
    },
	{
        path: '/team/switch',
        component: () => import(/* webpackChunkName: "TeamSwitch" */ '@/views/Private/Pages/Team/Switch')
    },
	{
        path: '/team/fallback',
        component: () => import(/* webpackChunkName: "TeamFallback" */ '@/views/Private/Pages/Team/Fallback')
    },
    {
        path: '/devices',
        component: () => import(/* webpackChunkName: "Devices" */ '@/views/Private/Pages/Devices/View')
    },
    {
        path: '/presentations',
        component: () => import(/* webpackChunkName: "Presentations" */ '@/views/Private/Pages/Presentations/View')
    },
	{
		path: '/presentations/:id',
		component: () => import(/* webpackChunkName: "PresentationsSetup" */ '@/views/Private/Pages/Presentations/Setup')
	},
	{
		path: '/schedules',
		component: () => import(/* webpackChunkName: "Schedules" */ '@/views/Private/Pages/Schedules/View')
	},
	{
        path: '/schedules/:id',
        component: () => import(/* webpackChunkName: "ScheduleSetup" */ '@/views/Private/Pages/Schedules/Setup')
    },
	{
		path: '/usage',
		component: () => import(/* webpackChunkName: "Usage" */ '@/views/Private/Pages/Usage')
	},
	{
		path: '/logs',
		component: () => import(/* webpackChunkName: "Logs" */ '@/views/Private/Pages/Logs')
	},
	{
		path: '/media',
		component: () => import(/* webpackChunkName: "Media" */ '@/views/Private/Pages/Media')
	},
	{
		path: '/administration/languages',
		component: () => import(/* webpackChunkName: "AdministrationLanguages" */ '@/views/Private/Pages/Administration/Languages')
	},
	{
		path: '/administration/environment',
		component: () => import(/* webpackChunkName: "AdministrationEnvironment" */ '@/views/Private/Pages/Administration/Environment')
	},
	{
		path: '/administration/accounts',
		component: () => import(/* webpackChunkName: "AdministrationAccounts" */ '@/views/Private/Pages/Administration/Accounts')
	},
	{
		path: '/administration/vouchers',
		component: () => import(/* webpackChunkName: "AdministrationVouchers" */ '@/views/Private/Pages/Administration/Vouchers')
	},
	{
		path: '/help',
		component: () => import(/* webpackChunkName: "Help" */ '@/views/Private/Pages/Help/View')
	},
	{
        path: '/help/:category',
        component: () => import(/* webpackChunkName: "HelpCategory" */ '@/views/Private/Pages/Help/Category')
    },
    {
        path: '*',
        redirect: '/'
    }
]
